import { useNavigate } from 'react-router-dom';
import { useInboxFavorites } from './use-inbox-favorites';
import { DEFAULT_INBOX_ID } from './use-all-inboxes';


export const usePrimaryInbox = () => {
    const navigate = useNavigate();
    const { data: favorites, isFetched } = useInboxFavorites();

    const primaryInboxId = favorites?.find(fav => fav.is_primary)?.inbox_id ?? DEFAULT_INBOX_ID;

    return {
        goToPrimaryInbox() {
            if (isFetched) {
                navigate(`/landlord/inner/inboxes/${primaryInboxId}`);
            }
        },
        goToInboxesList() {
            navigate('/landlord/inner/inboxes');
        },
        primaryInboxId,
        isReady: isFetched,
    };
};
